import { SupportedUploadType } from '../types'

export function getEffectiveAllowedMimes(
  supported: SupportedUploadType[] | undefined,
  allowedFromConfig: string[] | null | undefined,
): string[] {
  const allMimes = (supported ?? []).map((s) => s.mime_type)
  if (!allowedFromConfig || allowedFromConfig.length === 0) {
    return allMimes
  }
  const allowedSet = new Set(allowedFromConfig)
  return allMimes.filter((m) => allowedSet.has(m))
}

export function buildInputAcceptString(
  effectiveMimes: string[],
  supported: SupportedUploadType[] | undefined,
): string {
  const lookup = new Map<string, string[]>()
  for (const entry of supported ?? []) {
    lookup.set(entry.mime_type, entry.extensions)
  }
  const extensions = new Set<string>()
  for (const mime of effectiveMimes) {
    for (const ext of lookup.get(mime) ?? []) {
      extensions.add(ext)
    }
  }
  return Array.from(extensions).sort().join(',')
}

function normalizedExtension(filename: string): string | null {
  const trimmed = filename.trim()
  const dot = trimmed.lastIndexOf('.')
  if (dot <= 0 || dot === trimmed.length - 1) return null
  return trimmed.slice(dot).toLowerCase()
}

export function isUploadAllowed(
  file: File,
  effectiveMimes: Set<string>,
  supported?: SupportedUploadType[],
): boolean {
  if (effectiveMimes.size === 0) return true
  if (file.type && effectiveMimes.has(file.type)) return true

  const ext = normalizedExtension(file.name)
  if (ext && supported?.length) {
    for (const entry of supported) {
      if (!effectiveMimes.has(entry.mime_type)) continue
      for (const raw of entry.extensions) {
        const e = raw.startsWith('.') ? raw.toLowerCase() : `.${raw.toLowerCase()}`
        if (e === ext) return true
      }
    }
  }

  // No extension or unknown type: Backend still validates with magic.
  if (!file.type || file.type === 'application/octet-stream') return true

  return false
}
